const API_VERSION = "1.0.0";

export let SITE_NAME = "Cinomart";
export let CURRENCY = "৳";

const ROOT_URL = "https://api.cinomart.com";
export const IMAGE_URL = "https://api.cinomart.com";
export const FILE_URL = "https://api.cinomart.com";

// const ROOT_URL = "http://localhost:6002";
// export const IMAGE_URL = "http://localhost:6002";
// export const FILE_URL = "http://localhost:6002";

const API_URL = `${ROOT_URL}/api/v/${API_VERSION}`;

export const PUBLIC_API_URL = `${API_URL}`;
export const PRIVATE_API_URL = `${API_URL}`;

//auth
export const LOGIN_URL = `${PUBLIC_API_URL}/login`;
export const REFRESH_TOKEN = `${PRIVATE_API_URL}/login/refresh-token`;

//products
export const GET_PRODUCT_LIST = `${PRIVATE_API_URL}/products/private-products`;
export const GET_PRODUCT_BY_ID = `${PRIVATE_API_URL}/products/id`;
export const CREATE_PRODUCT_URL = `${PRIVATE_API_URL}/products/create`;
export const UPDATE_PRODUCT_URL = `${PRIVATE_API_URL}/products/update`;
export const VERIFY_PRODUCT_URL = `${PRIVATE_API_URL}/products/verify`;
export const DELETE_PRODUCT_URL = `${PRIVATE_API_URL}/products/delete`;
export const APPLY_SUBSCRIPTION_PLAN = `${PRIVATE_API_URL}/products/apply-subscription-plan`;
export const CHANGE_PRODUCT_APPROVAL_STATUS_URL = `${PRIVATE_API_URL}/products/approval-status`;
export const PRODUCT_ACTIVATE_DEACTIVATE_URL = `${PRIVATE_API_URL}/products/activate-or-deactivate`;

//product-variants
export const CREATE_VARIANT_URL = `${PRIVATE_API_URL}/product-variants/create`;
export const UPDATE_VARIANT_URL = `${PRIVATE_API_URL}/product-variants/update`;
export const DELETE_VARIANT_URL = `${PRIVATE_API_URL}/product-variants/delete`;

//product-review
export const GET_PRODUCT_REVIEW_BY_ID = `${PRIVATE_API_URL}/product-review/productId`;
export const DELETE_PRODUCT_REVIEW = `${PRIVATE_API_URL}/product-review/delete`;
export const UPDATE_PRODUCT_REVIEW = `${PRIVATE_API_URL}/product-review/update`;
export const APPROVE_PRODUCT_REVIEW = `${PRIVATE_API_URL}/product-review/approve`;

//users
export const GET_USER_LIST = `${PRIVATE_API_URL}/users`;
export const GET_USER_PROFILE = `${PRIVATE_API_URL}/users/profile`;
export const GET_USER_BY_ID = `${PRIVATE_API_URL}/users/id`;
export const CREATE_USER_URL = `${PRIVATE_API_URL}/users/create`;
export const UPDATE_USER_URL = `${PRIVATE_API_URL}/users/update`;
export const DELETE_USER_URL = `${PRIVATE_API_URL}/users/delete`;
export const CHANGE_PASSWORD_URL = `${PRIVATE_API_URL}/users/change-user-password`;
export const CHANGE_SELF_PASSWORD_URL = `${PRIVATE_API_URL}/users/updatePassword`;
export const CHANGE_USER_ACTIVE_STATUS_URL = `${PRIVATE_API_URL}/users/active-status`;

//sellers
export const GET_SELLER_LIST = `${PRIVATE_API_URL}/sellers`;
export const CREATE_SELLER_PROFILE_URL = `${PRIVATE_API_URL}/sellers/seller-profile/create`;
export const UPDATE_SELLER_PROFILE_URL = `${PRIVATE_API_URL}/sellers/seller-profile/update`;
export const UPDATE_SELLER_PROFILE_BY_ADMIN_URL = `${PRIVATE_API_URL}/sellers/seller-profile/update-admin`;
export const VERIFY_SELLER_URL = `${PRIVATE_API_URL}/sellers/verify`;
export const CHANGE_SELLER_VERIFICATION_STATUS_URL = `${PRIVATE_API_URL}/sellers/verification-status`;
export const CHANGE_SELLER_ACTIVE_STATUS_URL = `${PRIVATE_API_URL}/sellers/active-status`;

//sellers - phone management
export const CREATE_SELLER_PHONE_URL = `${PRIVATE_API_URL}/sellers/seller-phone/create`;
export const UPDATE_SELLER_PHONE_URL = `${PRIVATE_API_URL}/sellers/seller-phone/update`;
export const DELETE_SELLER_PHONE_URL = `${PRIVATE_API_URL}/sellers/seller-phone/delete`;

//sellers - pickup address management
export const CREATE_SELLER_PICKUP_ADDRESS_URL = `${PRIVATE_API_URL}/sellers/pickup-address/create`;
export const UPDATE_SELLER_PICKUP_ADDRESS_URL = `${PRIVATE_API_URL}/sellers/pickup-address/update`;
export const DELETE_SELLER_PICKUP_ADDRESS_URL = `${PRIVATE_API_URL}/sellers/pickup-address/delete`;

//sellers - accounts
export const GET_SELLER_ACCOUNTS = `${PRIVATE_API_URL}/sellers/accounts`;

//sellers - seller ledger & payments
export const GET_SELLER_LEDGER_LIST = `${PRIVATE_API_URL}/sellers/ledgers`;
export const POST_SELLER_LEDGER_URL = `${PRIVATE_API_URL}/sellers/payment/create`;
export const CANCEL_SELLER_LEDGER_URL = `${PRIVATE_API_URL}/sellers/payment/cancel`;

//sellers - change subscription plan
export const CHANGE_SUBSCRIPTION_PLAN = `${PRIVATE_API_URL}/sellers/change-subscription-plan`;

//companies
export const GET_COMPANY_LIST = `${PRIVATE_API_URL}/companies/private`;
export const GET_COMPANY_BY_ID = `${PRIVATE_API_URL}/companies/id`;
export const POST_COMPANY_URL = `${PRIVATE_API_URL}/companies/create`;
export const UPDATE_COMPANY_URL = `${PRIVATE_API_URL}/companies/update`;
export const DELETE_COMPANY_URL = `${PRIVATE_API_URL}/companies/delete`;
export const CHANGE_VERIFICATION_STATUS_COMPANY_URL = `${PRIVATE_API_URL}/companies/verify`;
export const CHANGE_COMPANY_ACTIVE_STATUS_URL = `${PRIVATE_API_URL}/companies/active`;

//warehouses
export const GET_WAREHOUSE_LIST = `${PRIVATE_API_URL}/warehouses`;
export const GET_WAREHOUSE_BY_ID = `${PRIVATE_API_URL}/warehouses/id`;
export const POST_WAREHOUSE_URL = `${PRIVATE_API_URL}/warehouses/create`;
export const UPDATE_WAREHOUSE_URL = `${PRIVATE_API_URL}/warehouses/update`;
export const DELETE_WAREHOUSE_URL = `${PRIVATE_API_URL}/warehouses/delete`;

//banners
export const GET_BANNER_LIST = `${PRIVATE_API_URL}/banners/private`;
export const GET_BANNER_BY_ID = `${PRIVATE_API_URL}/banners/id`;
export const POST_BANNER_URL = `${PRIVATE_API_URL}/banners/create`;
export const UPDATE_BANNER_URL = `${PRIVATE_API_URL}/banners/update`;
export const DELETE_BANNER_URL = `${PRIVATE_API_URL}/banners/delete`;

//static-pages
export const GET_STATIC_PAGE_BY_TITLE = `${PRIVATE_API_URL}/static-pages/title`;
export const GET_STATIC_PAGE_LIST = `${PRIVATE_API_URL}/static-pages`;
export const GET_STATIC_PAGE_BY_ID = `${PRIVATE_API_URL}/static-pages/id`;
export const POST_STATIC_PAGE_URL = `${PRIVATE_API_URL}/static-pages/create`;
export const UPDATE_STATIC_PAGE_URL = `${PRIVATE_API_URL}/static-pages/update`;
export const DELETE_STATIC_PAGE_URL = `${PRIVATE_API_URL}/static-pages/delete`;

//roles
export const GET_ROLE_LIST = `${PRIVATE_API_URL}/roles`;
export const GET_ROLE_BY_ID = `${PRIVATE_API_URL}/roles/id`;
export const POST_ROLE_URL = `${PRIVATE_API_URL}/roles/create`;
export const UPDATE_ROLE_URL = `${PRIVATE_API_URL}/roles/update`;
export const ALL_PERMISSION_URL = `${PRIVATE_API_URL}/roles/all-permissions`;
export const GET_USER_PERMISSIONS_URL = `${PRIVATE_API_URL}/roles/user-permissions`;

//stocks
export const GET_STOCK_LIST = `${PRIVATE_API_URL}/stocks`;
export const GET_STOCK_BY_ID = `${PRIVATE_API_URL}/stocks/id`;
export const POST_STOCK_URL = `${PRIVATE_API_URL}/stocks/create`;
export const UPDATE_STOCK_URL = `${PRIVATE_API_URL}/stocks/update`;
export const VERIFY_STOCK_URL = `${PRIVATE_API_URL}/stocks/verify`;
export const DELETE_STOCK_URL = `${PRIVATE_API_URL}/stocks/delete`;

//stock adjustments
export const CREATE_STOCK_ADJUSTMENTS_URL = `${PRIVATE_API_URL}/stock-adjustments/create`;

//stock-outs
export const GET_STOCK_OUT_LIST = `${PRIVATE_API_URL}/stock-outs`;
export const GET_STOCK_OUT_BY_ID = `${PRIVATE_API_URL}/stock-outs/id`;
export const POST_STOCK_OUT_URL = `${PRIVATE_API_URL}/stock-outs/create`;
export const UPDATE_STOCK_OUT_URL = `${PRIVATE_API_URL}/stock-outs/update`;
export const DELETE_STOCK_OUT_URL = `${PRIVATE_API_URL}/stock-outs/delete`;
export const VERIFY_STOCK_OUT_URL = `${PRIVATE_API_URL}/stock-outs/verify`;
export const GET_WAREHOUSES_TO_SEND_STOCK = `${PRIVATE_API_URL}/stock-outs/warehouses-to-send-stock`;

//categories
export const GET_CATEGORY_LIST = `${PRIVATE_API_URL}/categories/private`;
export const GET_PARENT_CATEGORY_LIST = `${PRIVATE_API_URL}/categories/parents`;
export const GET_CATEGORY_BY_ID = `${PRIVATE_API_URL}/categories/id`;
export const POST_CATEGORY_URL = `${PRIVATE_API_URL}/categories/create`;
export const UPDATE_CATEGORY_URL = `${PRIVATE_API_URL}/categories/update`;
export const DELETE_CATEGORY_URL = `${PRIVATE_API_URL}/categories/delete`;
export const MAKE_HOT_CATEGORY_URL = `${PRIVATE_API_URL}/categories/hot`;
export const CHANGE_VERIFICATION_STATUS_CATEGORY_URL = `${PRIVATE_API_URL}/categories/verify`;
export const CHANGE_CATEGORY_ACTIVE_STATUS_URL = `${PRIVATE_API_URL}/categories/active`;

//orders
export const GET_ORDER_LIST_URL = `${PRIVATE_API_URL}/orders`;
export const GET_ORDER_BY_ID_URL = `${PRIVATE_API_URL}/orders/id`;
export const PROCESS_ORDER_URL = `${PRIVATE_API_URL}/orders/process`;
export const UPDATE_ORDER_URL = `${PRIVATE_API_URL}/orders/update/id`;
export const DELETE_ORDER_URL = `${PRIVATE_API_URL}/orders/delete`;
export const MARK_COD_PAID_ORDER_URL = `${PRIVATE_API_URL}/orders/mark-cod-paid`;

//carts
export const UPDATE_CART_URL = `${PRIVATE_API_URL}/carts/update/id`;

//homepage-products
export const GET_HOME_PAGE_PRODUCT_LIST = `${PRIVATE_API_URL}/products/homepage-products/private`;
export const GET_HOME_PAGE_PRODUCT_BY_ID = `${PRIVATE_API_URL}/products/homepage-products/id`;
export const POST_HOME_PAGE_PRODUCT_URL = `${PRIVATE_API_URL}/products/homepage-products/create`;
export const UPDATE_HOME_PAGE_PRODUCT_URL = `${PRIVATE_API_URL}/products/homepage-products/update`;
export const CHANGE_ACTIVE_STATUS_HOME_PAGE_PRODUCT_URL = `${PRIVATE_API_URL}/products/homepage-products/active`;
export const DELETE_HOME_PAGE_PRODUCT_URL = `${PRIVATE_API_URL}/products/homepage-products/delete`;

//featured-products
export const GET_FEATURED_PRODUCT_LIST = `${PRIVATE_API_URL}/products/featured-products/private`;
export const GET_FEATURED_PRODUCT_BY_ID = `${PRIVATE_API_URL}/products/featured-products/id`;
export const POST_FEATURED_PRODUCT_URL = `${PRIVATE_API_URL}/products/featured-products/create`;
export const UPDATE_FEATURED_PRODUCT_URL = `${PRIVATE_API_URL}/products/featured-products/update`;
export const DELETE_FEATURED_PRODUCT_URL = `${PRIVATE_API_URL}/products/featured-products/delete`;

//daily-deals
export const GET_DAILY_DEALS_PRODUCT_LIST = `${PRIVATE_API_URL}/products/daily-deals/private`;
export const GET_DAILY_DEALS_PRODUCT_BY_ID = `${PRIVATE_API_URL}/products/daily-deals/id`;
export const POST_DAILY_DEALS_PRODUCT_URL = `${PRIVATE_API_URL}/products/daily-deals/create`;
export const UPDATE_DAILY_DEALS_PRODUCT_URL = `${PRIVATE_API_URL}/products/daily-deals/update`;
export const DELETE_DAILY_DEALS_PRODUCT_URL = `${PRIVATE_API_URL}/products/daily-deals/delete`;

//best-seller
export const GET_BEST_SELLER_PRODUCT_LIST = `${PRIVATE_API_URL}/products/best-seller/private`;
export const GET_BEST_SELLER_PRODUCT_BY_ID = `${PRIVATE_API_URL}/products/best-seller/id`;
export const POST_BEST_SELLER_PRODUCT_URL = `${PRIVATE_API_URL}/products/best-seller/create`;
export const UPDATE_BEST_SELLER_PRODUCT_URL = `${PRIVATE_API_URL}/products/best-seller/update`;
export const DELETE_BEST_SELLER_PRODUCT_URL = `${PRIVATE_API_URL}/products/best-seller/delete`;

//image upload
export const UPLOAD_BANNER_IMAGE = `${PRIVATE_API_URL}/upload/banner`;
export const UPLOAD_CATEGORY_IMAGE = `${PRIVATE_API_URL}/upload/category-icon`;
export const UPLOAD_COMPANY_IMAGE = `${PRIVATE_API_URL}/upload/company`;
export const UPLOAD_ORDER_IMAGES = `${PRIVATE_API_URL}/upload/order-images`;
export const UPLOAD_PRODUCT_IMAGE = `${PRIVATE_API_URL}/upload/product-image`;
export const UPLOAD_PROFILE_PICTURE = `${PRIVATE_API_URL}/upload/profile-picture`;
export const UPLOAD_SELLER_DOC = `${PRIVATE_API_URL}/upload/seller-doc`;
export const UPLOAD_SELLER_IMAGE = `${PRIVATE_API_URL}/upload/seller-images`;
export const UPLOAD_SITE_IMAGE = `${PRIVATE_API_URL}/upload/site-images`;
export const UPLOAD_PRODUCT_BUNDLE_OFFER_IMAGE = `${PRIVATE_API_URL}/upload/product-bundle-offer`;

//global-configs
export const GET_GLOBAL_CONFIG_LIST = `${PRIVATE_API_URL}/global-configs`;
export const GET_GLOBAL_CONFIG_BY_ID = `${PRIVATE_API_URL}/global-configs/id`;
export const POST_GLOBAL_CONFIG_URL = `${PRIVATE_API_URL}/global-configs/create`;
export const UPDATE_GLOBAL_CONFIG_URL = `${PRIVATE_API_URL}/global-configs/update`;
export const DELETE_GLOBAL_CONFIG_URL = `${PRIVATE_API_URL}/global-configs/delete`;
export const MAKE_ACTIVE_GLOBAL_CONFIG_URL = `${PRIVATE_API_URL}/global-configs/active-status`;

//promo-codes
export const GET_PROMO_CODE_LIST = `${PRIVATE_API_URL}/promo-codes`;
export const GET_PROMO_CODE_BY_ID = `${PRIVATE_API_URL}/promo-codes/id`;
export const POST_PROMO_CODE_URL = `${PRIVATE_API_URL}/promo-codes/create`;
export const UPDATE_PROMO_CODE_URL = `${PRIVATE_API_URL}/promo-codes/update`;
export const DELETE_PROMO_CODE_URL = `${PRIVATE_API_URL}/promo-codes/delete`;

//areas
export const GET_AREA_LIST = `${PRIVATE_API_URL}/areas/private`;
export const GET_AREA_BY_ID = `${PRIVATE_API_URL}/areas/id`;
export const POST_AREA_URL = `${PRIVATE_API_URL}/areas/create`;
export const UPDATE_AREA_URL = `${PRIVATE_API_URL}/areas/update`;
export const DELETE_AREA_URL = `${PRIVATE_API_URL}/areas/delete`;

//delivery-partners
export const GET_DELIVERY_PARTNER_LIST = `${PRIVATE_API_URL}/delivery-partners`;
export const GET_DELIVERY_PARTNER_BY_ID = `${PRIVATE_API_URL}/delivery-partners/id`;
export const POST_DELIVERY_PARTNER_URL = `${PRIVATE_API_URL}/delivery-partners/create`;
export const UPDATE_DELIVERY_PARTNER_URL = `${PRIVATE_API_URL}/delivery-partners/update`;
export const DELETE_DELIVERY_PARTNER_URL = `${PRIVATE_API_URL}/delivery-partners/delete`;
export const GET_DELIVERY_PARTNER_ACCOUNTS = `${PRIVATE_API_URL}/delivery-partners/accounts`;

//product-bundle-offer
export const GET_PRODUCT_BUNDLE_OFFER_LIST = `${PRIVATE_API_URL}/product-bundle-offers/private`;
export const GET_PRODUCT_BUNDLE_OFFER_BY_ID = `${PRIVATE_API_URL}/product-bundle-offers/id`;
export const POST_PRODUCT_BUNDLE_OFFER_URL = `${PRIVATE_API_URL}/product-bundle-offers/create`;
export const UPDATE_PRODUCT_BUNDLE_OFFER_URL = `${PRIVATE_API_URL}/product-bundle-offers/update`;
export const DELETE_PRODUCT_BUNDLE_OFFER_URL = `${PRIVATE_API_URL}/product-bundle-offers/delete`;

//campaign
export const GET_CAMPAIGN_LIST = `${PRIVATE_API_URL}/campaigns/private`;
export const GET_CAMPAIGN_BY_ID = `${PRIVATE_API_URL}/campaigns/id`;
export const POST_CAMPAIGN_URL = `${PRIVATE_API_URL}/campaigns/create`;
export const UPDATE_CAMPAIGN_URL = `${PRIVATE_API_URL}/campaigns/update`;
export const DELETE_CAMPAIGN_URL = `${PRIVATE_API_URL}/campaigns/delete`;

//delivery-partners ledger
export const GET_DELIVERY_PARTNER_LEDGER_LIST = `${PRIVATE_API_URL}/delivery-partners/ledgers`;
export const POST_DELIVERY_PARTNER_LEDGER_URL = `${PRIVATE_API_URL}/delivery-partners/payment/create`;
export const CANCEL_DELIVERY_PARTNER_LEDGER_URL = `${PRIVATE_API_URL}/delivery-partners/payment/cancel`;

//subscription-plans
export const GET_SUBSCRIPTION_PLAN_LIST = `${PRIVATE_API_URL}/subscription-plans`;
export const GET_SUBSCRIPTION_PLAN_BY_ID = `${PRIVATE_API_URL}/subscription-plans/id`;
export const POST_SUBSCRIPTION_PLAN_URL = `${PRIVATE_API_URL}/subscription-plans/create`;
export const UPDATE_SUBSCRIPTION_PLAN_URL = `${PRIVATE_API_URL}/subscription-plans/update`;
export const DELETE_SUBSCRIPTION_PLAN_URL = `${PRIVATE_API_URL}/subscription-plans/delete`;

//customer-groups
export const GET_CUSTOMER_GROUP_LIST = `${PRIVATE_API_URL}/customer-groups`;
export const GET_CUSTOMER_GROUP_BY_ID = `${PRIVATE_API_URL}/customer-groups/id`;
export const POST_CUSTOMER_GROUP_URL = `${PRIVATE_API_URL}/customer-groups/create`;
export const UPDATE_CUSTOMER_GROUP_URL = `${PRIVATE_API_URL}/customer-groups/update`;
export const DELETE_CUSTOMER_GROUP_URL = `${PRIVATE_API_URL}/customer-groups/delete`;

//chatting
export const GET_ALL_CHATTING_LIST = `${PRIVATE_API_URL}/chatting/chatting-list`;
export const GET_CHATTING_HISTORY_BY_USER_ID = `${PRIVATE_API_URL}/chatting/history/id`;

//dashboard
export const GET_NOTIFICATION_LIST = `${PRIVATE_API_URL}/dashboard/notifications`;
export const GET_ADMIN_DASHBOARD_STATS_URL = `${PRIVATE_API_URL}/dashboard/admin-stats`;
export const GET_VENDOR_DASHBOARD_STATS_URL = `${PRIVATE_API_URL}/dashboard/vendor-stats`;

//Token & Profile
export const ACCESS_TOKEN = "cinomart-auth-token";
export const PROFILE = "cinomart-profile";

//Order State
export const ORDER_STATE_SEQUENCE = {
	INITIATED: "DELIVERY_MAN_PICKED",
	// SUPPLIER_ACCEPTED: "DELIVERY_MAN_PICKED", // Flow 2 — deferred
	DELIVERY_MAN_PICKED: "COMPLETED",
	COMPLETED: "",
};

export const INITIATED = "INITIATED";
// export const SUPPLIER_ACCEPTED = "SUPPLIER_ACCEPTED"; // Flow 2 — deferred
export const DELIVERY_MAN_PICKED = "DELIVERY_MAN_PICKED";
export const COMPLETED = "COMPLETED";
export const CANCELED = "CANCELED";

export const ORDER_STATE_COLOR = {
	INITIATED: "orange",
	// SUPPLIER_ACCEPTED: "cyan", // Flow 2 — deferred
	DELIVERY_MAN_PICKED: "blue",
	COMPLETED: "green",
	CANCELED: "red",
};

// Currency
export const BD_TK_SIGN = "৳ ";

// Gender
export const GENDER_COLOR = {
	MALE: "blue",
	FEMALE: "green",
	OTHERS: "purple",
};

export const COMPANY = {
	name: "Cinomart",
	address: "Road 6, Block G, Banasree, Dhaka 1219",
};

//end
